import React from 'react';
import { FormGroup, FormLabel, FormHint, FormError } from './form-group';
import { cn } from 'src/lib/utils';

const textareaClasses =
  'flex min-h-[80px] w-full rounded-lg border-[1.5px] border-input bg-transparent px-3.5 py-2 text-sm shadow-sm transition-all duration-200 placeholder:text-muted-foreground hover:border-primary focus-visible:outline-none focus-visible:border-primary focus-visible:ring-[3px] focus-visible:ring-primary/15 disabled:cursor-not-allowed disabled:opacity-50 resize-y';

const TextareaField = React.forwardRef(function TextareaField(
  { label, id, hint, error, className, rows = 4, ...textareaProps },
  ref,
) {
  const inputId = id || `textarea-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <FormGroup className={cn(className)}>
      {label && <FormLabel htmlFor={inputId}>{label}</FormLabel>}
      <textarea
        ref={ref}
        id={inputId}
        rows={rows}
        className={cn(
          textareaClasses,
          error && 'border-destructive focus-visible:border-destructive focus-visible:ring-destructive/12',
          className,
        )}
        {...textareaProps}
      />
      {hint && !error && <FormHint>{hint}</FormHint>}
      {error && <FormError>{error}</FormError>}
    </FormGroup>
  );
});

export { TextareaField };
